import { useQuery } from '@tanstack/react-query'
import { getCMSHomepageContent } from '@mindfulchefuk/features/CMS/services/getCMSHomepageContent'

export const useServerSideQueryHomepageCMS = () =>
  useQuery({
    queryKey: ['cms-page-homepage'],
    queryFn: getCMSHomepageContent,
  })
